const { MinimogThemeStyles, MinimogThemeScripts } = window;
class QuickView {
  constructor() {
    this.modal = new MinimogTheme.Modal();
		this.isOpen = false
    this.activeRequestId = 0
    this.assetLoadTimeout = 10000

    addEventDelegate({
      selector: ".m-product-quickview-button",
      handler: (e, target) => {
        e.preventDefault();
        if (target.classList.contains("m-spinner-loading")) return;
        this.toggleLoading(target, true);
        const productHandle = target.dataset.productHandle;
        if (!productHandle) {
          this.toggleLoading(target, false);
          return;
        }
        const requestId = ++this.activeRequestId;
        this.fetchHtml(productHandle, target, requestId);
      },
    });

    window.MinimogEvents.subscribe(MinimogTheme.pubSubEvents.cartUpdate, () => {
      if (this.modal) MinimogTheme.ProductQuickView.close()
    });
  }

  fetchHtml(productHandle, target = null, requestId = ++this.activeRequestId) {
    loadAssetsNew([MinimogThemeStyles.product, MinimogThemeStyles.productInventory], "quick-view-assets");
    return fetchSection("product-quickview", { url: `${window.MinimogSettings.base_url}products/${productHandle}` })
      .then((html) => {
        if (requestId !== this.activeRequestId) return;

        const modalContent = html.querySelector(".m-product-quickview");
        if (!modalContent) throw new Error("Quickview content not found");
        const firstModel = html.querySelector("product-model");
        if (firstModel) {
          loadAssetsNew(
            [
              MinimogThemeScripts.productModel,
              "https://cdn.shopify.com/shopifycloud/model-viewer-ui/assets/v1.0/model-viewer-ui.css",
            ],
            "product-model-assets"
          );
        }

        return this.loadAssets(
          [MinimogThemeScripts.productMedia, MinimogThemeScripts.variantsPicker, MinimogThemeScripts.productInventory],
          "variants-picker"
        ).then(() => {
          if (requestId !== this.activeRequestId) return;

          const colorScheme = modalContent.dataset.colorScheme;
          this.modal.removeChild();
          this.modal.appendChild(modalContent);
          this.modal.setWidth("960px");
          this.modal.open();
          this.modal.setSizes(`m-gradient ${colorScheme}`);
          this.isOpen = true
        });
      })
      .catch((error) => {
        if (requestId === this.activeRequestId) console.error("Failed to load quickview", error);
      })
      .finally(() => {
        this.toggleLoading(target, false);
      });
  }

  loadAssets(files, id) {
    return new Promise((resolve, reject) => {
      let settled = false;
      const settle = (handler, value) => {
        if (settled) return;
        settled = true;
        clearTimeout(timeoutId);
        handler(value);
      };
      const timeoutId = setTimeout(() => {
        settle(reject, new Error("Quickview assets load timeout"));
      }, this.assetLoadTimeout);

      try {
        loadAssetsNew(files, id, () => settle(resolve));
      } catch (error) {
        settle(reject, error);
      }
    });
  }

  close(e) {
    this.modal.close(e)
    this.isOpen = false
  }

  toggleLoading(target, loading) {
    if (!target) return;
    if (loading) {
      target.classList.add("m-spinner-loading");
    } else {
      target.classList.remove("m-spinner-loading");
    }
  }
}

MinimogTheme.ProductQuickView = new QuickView();
